import { Routes, Route } from "react-router-dom";

import PublicLayout from "../layouts/PublicLayout/PublicLayout";
import AdminLayout from "../layouts/AdminLayout/AdminLayout";
import OrderLayout from "../layouts/OrderLayout/OrderLayout";
import ClintLayout from "../layouts/ClintLayout/ClintLayout";
import ProtectedAdminRoute from "./ProtectedAdminRoute";
import ProtectedLocalPasswordRoute from "./ProtectedLocalPasswordRoute";

import Home from "../pages/Public/Home/Home";
import Login from "../pages/Auth/Login";
import ClintLogin from "../pages/Auth/ClintLogin";
import OrdersScreen from "../pages/Adminstration/AdminMainPage/Screens/OrdersScreen/OrdersScreen"
import MakeOrderSreen from "../pages/Adminstration/AdminMainPage/Screens/ClintMakeOrder/LocalScreenMakeOrder";
import MakeDrink from "../pages/Adminstration/AdminMainPage/Screens/ClintMakeOrder/Makedrink/Makedrinkpage";

import UserAdminDashboard from "../pages/Adminstration/UsersPagePos/UserAdminMainPage";
import AdminstrationPage from "../pages/Adminstration/AdminMainPage/AdminstrationPage";
import MenuPage from "../pages/Adminstration/AdminMainPage/AddMenuePages/MenuPage";
import MaterialsMainPage from "../pages/Adminstration/AdminMainPage/MaterialsPage/MaterialsMainPage";
import TablesPage from "../pages/Adminstration/AdminMainPage/Tables/TablesPage";
import InvoicesPage from "../pages/Adminstration/AdminMainPage/InvoicesPage/InvoicesPage";
import AdminUsersPage from "../pages/Adminstration/AdminMainPage/AdminUsersPage/AdminAccountsMainPage";
import ClintsPage from "../pages/Adminstration/AdminMainPage/ClintsPage/ClintsDataPage"
import ClintAiDrinksPage from "../pages/Adminstration/AdminMainPage/ClintAiDrinksPage/ClintAiDrinksPage";
import ConversationsAiAgentPage from "../pages/Adminstration/AdminMainPage/ConversationsAiAgentPage/ConversationsAiAgentPage";
import ScreensPage from "../pages/Adminstration/AdminMainPage/Screens/ScreenMainPage";
import KitchenScreen from "../pages/Adminstration/AdminMainPage/Screens/KitchenScreen/KitchenScreen"
import MaterialUsage from "../pages/Adminstration/AdminMainPage/StatisticsMaterialUsage/StatisticsMaterialUsagePage";
import OrderReportsPage from "../pages/Adminstration/AdminMainPage/OrderReports/OrderReportsPage";

import ProtectedRoutClint from "./ProtectedRoutClint";
import ClintMainPage from "../pages/Clint/ClintMainPage";
import ClintOrderHistory from "../pages/Clint/MyOldOrders/MyOldOrdersPage";
import MakeOrderPage from "../pages/Clint/MakeOrder/ClintMakeOrder/ClintMakeOrder";
import ClintMakeDrink from "../pages/Clint/MakeOrder/ClintMakeOrder/Makedrink/Makedrinkpage";
import Clintmenu from "../pages/Clint/Menu";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="login" element={<ClintLogin />} />
      </Route>
        <Route path="/background/gate/login" element={<Login />} />
        <Route path="/orders" element={<OrdersScreen />} />
        <Route
          path="/makeorder"
          element={
            <ProtectedLocalPasswordRoute>
              <MakeOrderSreen />
            </ProtectedLocalPasswordRoute>
          }
        />
        <Route
          path="/makedrink"
          element={
            <ProtectedLocalPasswordRoute>
              <MakeDrink />
            </ProtectedLocalPasswordRoute>
          }
        />

      {/* Protected Group admin */}
      <Route element={<ProtectedAdminRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="/adminstration/dashboard" element={<AdminstrationPage />} />
          <Route path="/adminstration/menu" element={<MenuPage />} />
          <Route path="/adminstration/materials" element={<MaterialsMainPage />} />
          <Route path="/adminstration/tables" element={<TablesPage />} />
          <Route path="/adminstration/invoices" element={<InvoicesPage />} />
          <Route path="/adminstration/users" element={<AdminUsersPage />} />
          <Route path="/adminstration/clint" element={<ClintsPage />} />
          <Route path="/adminstration/clintgeneratedrink" element={<ClintAiDrinksPage />} />
          <Route path="/adminstration/conversations" element={<ConversationsAiAgentPage />} />
          <Route path="/adminstration/screens" element={<ScreensPage />} />
          <Route path="/adminstration/materialusage" element={<MaterialUsage />} />
          <Route path="/adminstration/orderreports" element={<OrderReportsPage />} />

        </Route>

        <Route element={<OrderLayout />}>
          <Route path="/auth/pos-pages" element={<UserAdminDashboard />} />
        </Route>

        <Route path="/admin/kit" element={<KitchenScreen />} />
      </Route>

      {/* Protected Group Clint*/}
      <Route element={<ProtectedRoutClint allowed={["user"]} />}>
        <Route element={<ClintLayout />}>
          <Route path="/clint" element={<ClintMainPage />} />
          <Route path="/clint/orders/history" element={<ClintOrderHistory />} />
          <Route path="/clint/make-order" element={<MakeOrderPage />} />
          <Route path="/clint/make-drink" element={<ClintMakeDrink/>} />
          <Route path="/clint/menu" element={<Clintmenu />} />
        </Route>

      </Route>
      

      <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      
    </Routes>
  );
};

export default AppRoutes;
